import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-divider',
  imports: [],
  templateUrl: './breadcrumb-divider.component.html',
  styleUrls: ['./breadcrumb-divider.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbDividerComponent {}
